<ion-content>
  <ion-grid >
    <ion-row>
      <ion-col size="12" style="display: flex; justify-content: center; align-items: center">
        <ng-container *ngIf="videoUrl; else noInfo">
            <div class="fluidMedia" *ngIf="!youtube; else ytVid">
              <video
              class="responsive-iframe"
              #video
              id="video"
              controls
              (ended)="dismiss()"
              autoplay="true"
              [src]="videoUrl"
                   ></video>
            </div>
          <ng-template #ytVid>
            <div class="fluidMedia" *ngIf="!hasError">
              <!-- Contenedor para el reproductor de YouTube -->
              <div id="youtube-player" class="responsive-iframe"></div>
            </div>
            <div *ngIf="hasError" class="ion-text-center ion-padding">
              <ion-text color="danger">
                <p>Error al cargar el video de YouTube</p>
                <ion-icon name="warning-outline" style="font-size: 30px"></ion-icon>
              </ion-text>
            </div>
          </ng-template>
        </ng-container>

        <ng-template #noInfo>
          <ion-text class="ion-text-center">
            <p>Este vídeo no se encuentra disponible</p>
            <ion-icon name="warning-outline" style="font-size: 20px"></ion-icon>
          </ion-text>
        </ng-template>
        <ng-container *ngIf="isLoading">
          <ion-row>
            <ion-col
              size="12"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 200px;
              "
            >
              <ion-spinner></ion-spinner>
            </ion-col>
          </ion-row>
        </ng-container>
      </ion-col>

    </ion-row>
        <ion-row>
      <ion-col size="12" style="display: flex; justify-content: center; align-items: center; gap: 10px;">
        <ion-button
          size="small"
          color="primary"
          (click)="dismiss()"
        >
          <ion-icon name="close-outline" slot="start"></ion-icon>
          Cerrar
        </ion-button>
        <ion-button
          *ngIf="videoUrl && !hasError"
          size="small"
          [style]="youtube ? { '--background': '#FF0033' } : { '--background': '#000000' }"
          (click)="openInExternal()"
        >
          <ion-icon name="open-outline" slot="start"></ion-icon>
          {{ youtube ? 'Abrir en YouTube' : 'Abrir externamente' }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
